module.exports = __webpack_public_path__ + "static/media/error-icon.0204055e.svg";